import {createRouter, createWebHashHistory} from 'vue-router';
import {getUser} from './main'
import App from "@/App";
import {useEndpointStore} from "@/store/endpointStore";

const routes = [
    {
        path: '/',
        component: App,
        children: [
            {
                path: '/',
                name: 'esmo',
                beforeEnter() {
                    location.href = 'https://www.esmo.org'
                }
            },
            {
                path: '/newsletters',
                name: 'newsletters',
                component: () => import('./components/newsletters/PreferenceCentre.vue'),
                meta: {
                    apiKey: "6f170796-2dfe-446e-a4f1-d3b999360bb1"
                }
            },
            {
                path: '/aoi',
                name: 'aoi',
                component: () => import('./components/aoi/Aoi.vue'),
                meta: {
                    apiKey: "b07fa170-2aff-44b3-8b19-6e8929032927"
                }
            },
            {
                path: '/newsletters/unsubscribe',
                name: 'unsubscribe',
                component: () => import('./components/newsletters/Unsubscribe.vue'),
                meta: {
                    apiKey: "a5acd8e1-11dc-4028-a69c-0116c3e49099"
                }
            },
            {
                path: '/newsletters/scan',
                name: 'scanner',
                component: () => import('./components/Scanner.vue'),
                meta: {
                    apiKey: "a5acd8e1-11dc-4028-a69c-0116c3e49099",
                }
            },
            {
                path: '/totem',
                name: 'totem',
                component: () => import('./components/Totem.vue'),
            },
            {
                path: '/totem/newsletter',
                name: 'totem-newsletter',
                component: () => import('./components/newsletters/Totem.vue'),
                meta: {
                    apiKey: "a5acd8e1-11dc-4028-a69c-0116c3e49099",
                }
            },
            {
                path: '/totem/aoi',
                name: 'totem-aoi',
                component: () => import('./components/aoi/Totem.vue'),
                meta: {
                    apiKey: "a5acd8e1-11dc-4028-a69c-0116c3e49099",
                }
            }
        ]
    }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior() {
        return {left: 0, top: 0};
    }
});

router.beforeEach(function (to, from, next) {
    window.scrollTo(0, 0);
    if (to.matched.some(record => record.meta.apiKey != null)) {
        const  endpointStore =  useEndpointStore();
        endpointStore.setApiKey(to.meta.apiKey)
    }
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (getUser() == null || getUser().token == null ) {
            next('/')
            return
        }
    }
    next()
});

export default router;